import { Routes } from '@angular/router';

import { EditorDemoComponent } from './editor-demo.component';

export const editorRoutes: Routes = [
  { path: 'editor', component: EditorDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/editor/editor.routes.ts